import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { TopPvCategories, TopPvProducts } from '~/api/model';

// Response 타입 (Zod Model 재사용 — OAISchema 금지, api-typegen §0)
type TopPvProductsResponse = TopPvProducts;
type TopPvCategoriesResponse = TopPvCategories;

export type TopPvProductsParams = {
  /** 현재 시각 (0~23) */
  hour: number;
  /** 카테고리 스코프 */
  categoryId?: number;
};

export interface TopPvDataSource {
  getTopPvProducts(params: TopPvProductsParams): Promise<TopPvProductsResponse>;
  getTopPvCategories(hour: number): Promise<TopPvCategoriesResponse>;
}

export class TopPvDataSourceImpl implements TopPvDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getTopPvProducts(params: TopPvProductsParams) {
    return this.client.request<TopPvProductsResponse>({
      url: '/api/market-place/v1/top-pv/products',
      method: 'get',
      params: { ...params },
    });
  }

  async getTopPvCategories(hour: number) {
    return this.client.request<TopPvCategoriesResponse>({
      url: '/api/market-place/v1/top-pv/categories',
      method: 'get',
      params: { hour },
    });
  }
}

export const topPvDataSource = new TopPvDataSourceImpl();
